import { createRoot } from 'react-dom/client';

import { StoreProvider } from './state';
import { ApplicationWrapper } from './ApplicationWrapper';

const render = () => {
  root.render(
    <StoreProvider>
      <ApplicationWrapper />
    </StoreProvider>
  );
};

/*
  This Webpack module API call is required for Webpack Hot Reload to work.
  This will reload the contents of the app automatically on save without reloading the page entirely.
  It needs to live at the point in the dom/component tree immediately above React `root`.
*/
if (module.hot) {
  module.hot.accept('./ApplicationWrapper', () => {
    render();
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('No root element found');

const root = createRoot(container);
render();
